<mat-card>
    <app-data-grid-comp
        [isLoading]="isLoading"
        [height]="750"
        [columns]="columns"
        [pageSize]="pageSize"
        [skip]="skip"
        [gridDataResult]="gridDataResult"
        category="EmployeeGoals"
        export="excel"
        [sortable]="{
              mode: 'multiple'
          }"
        hideActionButtons="true"
        filterable="true"
        [filterCategories]="filterCategories"
        (emitFilterEvent)="filterCallback($event)"
        (emitPageChangeEvent)="pageChange($event)"
        (emitToggleFilter)="updateFilterToggleDetails($event)"
        [filterToggleDetails]="filterToggleDetails"
        (emitSortEvent)="sortChange($event)"
        [sortableColumns]="sortableColumns"
        export="customExcel"
        (emitExportEvent)="allData()"
    ></app-data-grid-comp>
</mat-card>

<kendo-excelexport
    [data]="excelData"
    [fileName]="fileName"
    #excelexport
>
    <kendo-excelexport-column
        *ngFor="let column of excelColumns"
        [field]="column.field"
        [title]="column.title"
    >
    </kendo-excelexport-column>
</kendo-excelexport>

